module.exports = __webpack_public_path__ + "img/activity.cfd83d73.png";